import { render, staticRenderFns } from "./RestorationFiles.vue?vue&type=template&id=dd84582c&scoped=true&"
import script from "./RestorationFiles.vue?vue&type=script&lang=js&"
export * from "./RestorationFiles.vue?vue&type=script&lang=js&"
import style0 from "./RestorationFiles.vue?vue&type=style&index=0&id=dd84582c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd84582c",
  null
  
)

export default component.exports